import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';

export class BeneficiaryFinancialInformationService extends ExportTypeBaseService {
  /**
   * @var {Estate}
   */
  estate;

  /**
   * @return {string}
   */
  getFilename() {
    this.estate = getters.export.getData().estate;
    return `${this.estate.contact.fullName.replaceAll(' ', '-')}-clearvault-summary.pdf`;
  }

  /**
   * @return {*}
   */
  getSnackBarTitle() {
    this.estate = getters.export.getData().estate;
    return Lang.t(
      "estatedistribution.of-information-now",
      {
        name: this.estate.contact.fullName
      }
    );
  }
}

export default new BeneficiaryFinancialInformationService();
